export const ownershipKeys = {
  all: ['ownership'] as const,
  FETCH_OWNERSHIP: (
    corporationId: number,
    offset?: number,
    limit?: number,
  ) =>
    ['ownership', 'overview', corporationId, offset, limit] as const,
  FETCH_INHERITABLE_UBOS: (
    corporationId: number,
    sourceCorporationId: number,
  ) =>
    [
      'ownership',
      'inheritable-ubos',
      corporationId,
      sourceCorporationId,
    ] as const,
  FETCH_DIRECTOR_DELETE_PREVIEW: (directorId: number) =>
    ['ownership', 'director-delete-preview', directorId] as const,
};
